export function HowToTab() {
  return (
    <div className="space-y-6">
      <section className="space-y-3">
        <h2 className="text-lg font-semibold">Getting Started</h2>
        <div className="text-sm text-muted-foreground space-y-2">
          <p>As a Super Admin, you have full system-level access. Here's how to set things up:</p>
          <ol className="list-decimal list-inside space-y-1.5 pl-1">
            <li>
              <strong>Create a Tenant</strong> — Each tenant is an isolated workspace. Go to the
              Manage tab and click <em>Add Tenant</em>.
            </li>
            <li>
              <strong>Configure Allowed Domains</strong> — In the tenant's Settings, add email
              domains to enable auto-provisioning.
            </li>
            <li>
              <strong>Add Dashboards</strong> — Navigate into a tenant and add Looker Studio embed
              URLs.
            </li>
          </ol>
        </div>
      </section>

      <section className="space-y-3">
        <h2 className="text-lg font-semibold">Roles Overview</h2>
        <div className="text-sm text-muted-foreground space-y-2">
          <ul className="list-disc list-inside space-y-1.5 pl-1">
            <li>
              <strong>Super Admin</strong> — Full system access across all tenants.
            </li>
            <li>
              <strong>Admin</strong> — Tenant-level access: manage users, dashboards, and settings
              within their assigned tenant.
            </li>
            <li>
              <strong>Viewer</strong> — Read-only access to assigned dashboards.
            </li>
          </ul>
        </div>
      </section>
    </div>
  );
}
